/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import { UserFragmentFragmentDoc } from './userFragment.generated';
import { CompanyFragmentFragmentDoc } from './companyFragment.generated';
export type Brand_Enum =
  /** G20 */
  | 'G20'
  /** Auchan Hyper */
  | 'auchan_hyper'
  /** Auchan MyAuchan */
  | 'auchan_myauchan'
  /** Auchan Super */
  | 'auchan_super'
  /** Biocoop */
  | 'biocoop'
  /** Carrefour City */
  | 'carrefour_city'
  /** Carrefour Contact */
  | 'carrefour_contact'
  /** Carrefour Express */
  | 'carrefour_express'
  /** Carrefour Hyper */
  | 'carrefour_hyper'
  /** Carrefour Market */
  | 'carrefour_market'
  /** Coccimarket */
  | 'coccimarket'
  /** Coccimarket City */
  | 'coccimarket_city'
  /** Coccimarket Easy */
  | 'coccimarket_easy'
  /** Cora */
  | 'cora'
  /** Diago */
  | 'diago'
  /** E.Leclerc */
  | 'e_leclerc'
  /** E.Leclerc Express */
  | 'e_leclerc_express'
  /** Franprix */
  | 'franprix'
  /** Hyper U */
  | 'hyper_u'
  /** Intermarché Contact */
  | 'intermarche_contact'
  /** Intermarché Express */
  | 'intermarche_express'
  /** Intermarché Hyper */
  | 'intermarche_hyper'
  /** Intermarché Super */
  | 'intermarche_super'
  /** Monop’ */
  | 'monop'
  /** Monoprix */
  | 'monoprix'
  /** Netto */
  | 'netto'
  /** Sitis Market */
  | 'sitis_market'
  /** Spar */
  | 'spar'
  /** Super U */
  | 'super_u'
  /** U Express */
  | 'u_express'
  /** Utile */
  | 'utile';

export type Business_Profile_Enum =
  | 'BUYER'
  | 'SUPPLIER';

export type Minimum_Order_Value_Type_Enum =
  | 'PACKAGING'
  | 'PRICE'
  | 'WEIGHT';

export type Order_Status_Enum =
  | 'closed_but_contested_payment'
  | 'order_archived'
  | 'order_being_paid_by_buyer'
  | 'order_cancelled'
  | 'order_closed'
  | 'order_to_be_billed_by_supplier'
  | 'order_to_be_delivered_by_supplier'
  | 'order_to_be_paid_by_buyer'
  | 'order_to_be_prepared_by_supplier'
  | 'order_to_be_received_by_buyer'
  | 'order_to_be_validated_by_buyer'
  | 'order_to_be_validated_by_supplier';

export type Payment_Method_Enum =
  | 'BANK_TRANSFER'
  | 'NO_PAYMENT'
  | 'SDD_AUTO'
  | 'SDD_TRIGGERED';

export type OrderFragmentFragment = { id: string, created_at: string, friendly_id: string, cancelled_by: Types.Business_Profile_Enum | null, updated_at: string, reference_id: string, delivery_date: string | null, payment_method: Types.Payment_Method_Enum | null, status: Types.Order_Status_Enum, sdd_payment_date: string | null, total_price_excl_tax: number | null, has_invoice_generation: boolean, user: { id: string, first_name: string, last_name: string, auth_provider_avatar_url: string | null, default_avatar: { domain: string | null, path: string } | null } | null, contract: { id: string, supplyingCompanyId: string, supplier_commission_rate: number | null, is_trusted_supplier: boolean, buyingCompanyId: string, minimum_order_value: number | null, minimum_order_value_type: Types.Minimum_Order_Value_Type_Enum, discount: number, custom_price_list_id: string | null, channel_url: string | null, supplying_company: { invoice_prefix: string, id: string, business_profile: Types.Business_Profile_Enum, description: string | null, contactEmail: string, contactPhoneNumber: string, tradeName: string, brand: Types.Brand_Enum | null, photos: Array<{ photo: { path: string, domain: string | null } }> }, buying_company: { invoice_prefix: string, id: string, business_profile: Types.Business_Profile_Enum, description: string | null, contactEmail: string, contactPhoneNumber: string, tradeName: string, brand: Types.Brand_Enum | null, addresses: Array<{ formattedAddress: string }>, delivery_hours: Array<{ opening_hour: string, closing_hour: string, week_day: string }>, photos: Array<{ photo: { path: string, domain: string | null } }> }, custom_price_list: { name: string, custom_price_list_packagings: Array<{ packaging_sku: number, company_id: string, discount: number }> } | null } };

export const OrderFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment orderFragment on order {
  id
  created_at
  friendly_id
  cancelled_by
  updated_at
  reference_id
  delivery_date
  payment_method
  status
  sdd_payment_date
  total_price_excl_tax
  has_invoice_generation
  user {
    ...userFragment
  }
  contract {
    id
    supplyingCompanyId
    supplier_commission_rate
    is_trusted_supplier
    supplying_company {
      ...companyFragment
      invoice_prefix
    }
    buyingCompanyId
    buying_company {
      ...companyFragment
      invoice_prefix
      addresses {
        formattedAddress
      }
      delivery_hours {
        opening_hour
        closing_hour
        week_day
      }
    }
    minimum_order_value
    minimum_order_value_type
    discount
    custom_price_list_id
    custom_price_list {
      name
      custom_price_list_packagings {
        packaging_sku
        company_id
        discount
      }
    }
    channel_url
  }
}
    ${UserFragmentFragmentDoc}
${CompanyFragmentFragmentDoc}`;